import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "transfer",
  "use": "transfer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"transfer\"><defs><style>#transfer .cls-1{fill:none}#transfer .cls-2{stroke:#000;stroke-width:.2px}</style></defs><title>资源 88</title><g id=\"transfer_图层_2\" data-name=\"图层 2\"><g id=\"transfer_图层_1-2\" data-name=\"图层 1\"><path id=\"transfer_Rectangle_35_Copy_7\" data-name=\"Rectangle 35 Copy 7\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"transfer_right-square-o\"><path id=\"transfer_Shape\" d=\"M20.83 22.51H3.18a1.69 1.69 0 0 1-1.69-1.68V3.18a1.68 1.68 0 0 1 1.69-1.69h17.65a1.69 1.69 0 0 1 1.69 1.69v17.65a1.69 1.69 0 0 1-1.69 1.68zM3.18 3.18v17.65h17.65V3.18z\" /></g><g id=\"transfer_arrowsalt\"><g id=\"transfer_swap\"><path id=\"transfer_Shape-2\" class=\"cls-2\" d=\"M14.14 17.7a.66.66 0 0 1 0-.94l2.15-2.14H6.23a.68.68 0 0 1-.7-.64.67.67 0 0 1 .64-.69h12.17l.05.05V14l-3.28 3.3a.67.67 0 0 1-.94 0zm-7.91-7H5.8v-.79L9 6.28a.66.66 0 0 1 .94 0 .67.67 0 0 1 0 .9L7.83 9.36h10.06a.67.67 0 0 1 0 1.33z\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/transfer.svg
// module id = KsWh
// module chunks = 6